import { Form, Formik } from "formik";
import React from "react";
import { toast } from "react-toastify";
import InputField from "../../atoms/InputField";
import Button from "../../atoms/Button";
import { PropagateLoader } from "react-spinners";
import { UPDATE_CLIENT } from "../../../api/apiAdmin";

const ModalEditClient = ({ client, onClose, refetch }) => {
    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.name) { errors.name = "El nombre es requerido"; }
        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const upperCaseValues = {
                ...values,
                name: values.name.toUpperCase(),
            };
            await UPDATE_CLIENT(client.id, upperCaseValues)
            toast.success("Registro exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { 
        name: client?.name || "", 
        email: client?.user?.email || "", 
        cellphone: client?.cellphone ||"", 
        password: client?.user.password || "",  
    }

    return(
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validate={validate}
            >
                {({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2">
                            <InputField name="name" label="Nombre completo" placeholder="Nombre completo" capitalize />
                            <InputField name="email" label="Correo electrónico" placeholder="CORREO ELECTRÓNICO" />
                            <InputField name="cellphone" label="Numero de telefono" placeholder="Número de teléfono" capitalize type="number" />
                            <InputField name="password" label="Contraseña" type="password" placeholder="CONTRASEÑA" />
                        </div>
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Actualizar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ModalEditClient;